import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";
import { useMemo } from "react";

const ACTIVITY_TAG_BASE = "/ActivityTags";

const getActivityTagAPI = () => API.get(`${ACTIVITY_TAG_BASE}`);

const addActivityTagAPI = (data) =>
  API.post(`${ACTIVITY_TAG_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateActivityTagAPI = (id, data) =>
  API.patch(`${ACTIVITY_TAG_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const baseService = createApplicationService({
  name: "activityTags",
  apiFetchFn: getActivityTagAPI,
  apiAddFn: addActivityTagAPI,
  apiUpdateFn: updateActivityTagAPI,
});

const activityTagReducer = baseService.reducer;
const getActivityTag = baseService.getData;
const addActivityTag = baseService.addData;
const updateActivityTag = baseService.updateData;
const useActivityTag = baseService.useData;

const useActiveActivityTags = () => {
  const { data, loading } = useActivityTag();
  const activeActivityTags = useMemo(
    () => data.filter((tag) => tag.active),
    [data],
  );
  return { data: activeActivityTags, loading };
};

export {
  activityTagReducer,
  getActivityTag,
  getActivityTagAPI,
  addActivityTag,
  updateActivityTag,
  useActivityTag,
  useActiveActivityTags,
};
